import { createContext, useContext } from 'react';

import LoadingOverlay from 'components/shared/table/LoadingOverlay';
import RehabState from 'models/RehabState';
import { useRehabStatesQuery } from 'services/api/rehabStates';

type RehabStateContextType = RehabState[];

const RehabStatesContext = createContext<RehabStateContextType>([]);

export const RehabStatesProvider = ({ children }) => {
  const { data: rehabStatesData, isPending } = useRehabStatesQuery();

  if (isPending) {
    return <LoadingOverlay />;
  }

  return <RehabStatesContext value={rehabStatesData?.data ?? []}>{children}</RehabStatesContext>;
};

export const useRehabStates = () => {
  const context = useContext(RehabStatesContext);
  if (!context) {
    throw new Error('useRehabStates must be used within a RehabStatesProvider');
  }

  if (context.length === 0) {
    throw new Error('No rehab states found');
  }
  return context;
};
